// Update review counts globally
document.addEventListener('DOMContentLoaded', function() {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  let node;
  while (node = walker.nextNode()) {
    node.textContent = node.textContent
      .replace(/25,000/g, '40,000')
      .replace(/30,000/g, '40,000')
      .replace(/35,000/g, '40,000')
      .replace(/35K/g, '40K');
  }
});